import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import register from '@/pages/register'
import addressSelect from '@/pages/AddressSelect'
import uploadCard from '@/pages/UploadIDCard'
import productDetail from '@/pages/ProductDetail'

import productsCenter from '@/pages/ProductsCenter'
import financingApplication from '@/pages/FinancingApplication'
import waitTask from '@/pages/WaitTask'
import finishTask from '@/pages/FinishTask';
import signFiles from "@/pages/SignFiles"
import personInfo from '@/pages/PersonInfo';
import filepdf from '@/components/filespdf';
import faceRecognition from '@/pages/FaceRecognition';
import queryUser from '@/pages/queryUser';
import loanDetail from '@/pages/LoanDetail';
import loanList from '@/pages/LoanList';
import LivefaceRecognition from '@/pages/LivefaceRecognition';
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'helloWorld',
            component: HelloWorld,
            meta: {
                pageTitle: 'hello'
            }
        },
        {
            path: '/register',
            name: 'register',
            component: register,
            meta: {
                pageTitle: '注册',
                keepAlive: true,
            }
        },
        {
            path: '/addressSelect',
            name: 'AddressSelect',
            component: addressSelect,
            meta: {
                pageTitle: '产品地址选择'
            }
        },
        {
            path: '/uploadCard',
            name: 'UploadCard',
            component: uploadCard,
            meta: {
                pageTitle: '身份证上传'
            }
        },
        {
            path: '/productDetail',
            name: 'ProductDetail',
            component: productDetail,
            meta: {
                pageTitle: '产品详情'
            }
        },
        {
            path: '/productsCenter',
            name: 'ProductsCenter',
            component: productsCenter,
            meta: {
                pageTitle: '贷款产品选择'
            }
        },
        {
            path: '/financingApplication',
            name: 'FinancingApplication',
            component: financingApplication,
            meta: {
                pageTitle: '融资申请'
            }
        },
        {
            path: '/waitTask',
            name: 'waitTask',
            component: waitTask,
            meta: {
                pageTitle: '待办任务'
            }
        },
        {
            path: '/finishTask',
            name: 'finishTask',
            component: finishTask,
            meta: {
                pageTitle: '已办任务'
            }
        },
        {
            path: '/signFiles',
            name: 'signFiles',
            component: signFiles,
            meta: {
                pageTitle: '签约文件'
            }
        },
        {
            path: '/personInfo',
            name: 'personInfo',
            component: personInfo,
            meta: {
                pageTitle: '个人信息'
            }
        },
        {
            path: '/filespdf',
            name: 'filespdf',
            component: filepdf,
            meta: {
                pageTitle: 'pdf文件预览'
            }
        },
        {
            path: '/faceRecognition',
            name: 'faceRecognition',
            component: faceRecognition,
            meta: {
                pageTitle: '人脸识别'
            }
        },
        {
            path: '/queryUser',
            name: 'queryUser',
            component: queryUser,
            meta: {
                pageTitle: '用户信息查询'
            }
        },
        {
            path: '/wecome/businessSelect',
            name: 'businessSelect',
            component: () =>
                import ('../wecome/businessSelect.vue'),
            meta: {
                title: '业务查询'
            }
        },
        {
            path: '/wecome/roomGuidePrice',
            name: 'roomGuidePrice',
            component: () =>
                import ('../wecome/roomGuidePrice.vue'),
            meta: {
                title: '房产指导价'
            }
        },
        {
            path: '/wecome/businessAccept',
            name: 'businessAccept',
            component: () =>
                import ('../wecome/businessAccept.vue'),
            meta: {
                title: '录入信息'
            }
        },
        {
            path: '/wecome/roomValuation',
            name: 'roomValuation',
            component: () =>
                import ('../wecome/roomValuation.vue'),
            meta: {
                title: '房屋估值'
            }
        },
        {
            path: '/wecome/lxwm',
            name: 'lxwm',
            component: () =>
                import ('../wecome/lxwm.vue'),
            meta: {
                title: '关于我们'
            }
        },
        {
            path: '/wecome/onlinebalance',
            name: 'onlinebalance',
            component: () =>
                import ('../wecome/onlinebalance.vue'),
            meta: {
                title: '在库余额表'
            }
        },
        {
            path: '/wecome/loanstatement',
            name: 'loanstatement',
            component: () =>
                import ('../wecome/loanstatement.vue'),
            meta: {
                title: '放贷子表'
            }
        },
        {
            path: '/wecome/loansummary',
            name: 'loansummary',
            component: () =>
                import ('../wecome/loansummary.vue'),
            meta: {
                title: '放贷总表'
            }
        },
        {
            path: '/loanList',
            name: 'loanList',
            component: loanList,
            meta: {
                title: '我的贷款'
            }
        },
        {
            path: '/loanDetail/:projectId',
            name: 'loanDetail',
            component: loanDetail,
            meta: {
                title: '我的贷款'
            }
        },
        // {
        //   name: 'approvals',
        //   component: () => import('./view/approvals.vue'),
        //   meta: {
        //     title: '审批意见'
        //   }
        // },

        {
            path: '/LivefaceRecognition',
            name: 'livefaceRecognition',
            component: LivefaceRecognition,
            meta: {
                title: '活体检测'
            }
        }
    ]


})


// WEBPACK FOOTER //
// ./src/router/index.js